import "./App.css";
import Header from "./componets/header/Header";
import Home from "./componets/home/Home";
import About from "./componets/about/About";
import Skills from "./componets/skills/Skills";
import Qualification from "./componets/qualification/Qualification";
import Testimonials from "./componets/testimonials/Testimonials";
import Footer from "./componets/footer/Footer";
import ScrollUp from "./componets/scrollup/ScrollUp";
import Project from "./componets/projects/Projects";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <Header />
      <main className="main">
        <Home />
        <About />
        <Project />
        <Skills />
        <Qualification />
        <Testimonials />
      </main>

      <Footer />
      <ScrollUp />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
